import {
  // Go Live
  GO_LIVE_START,
  GO_LIVE_SUCCESS,
  GO_LIVE_FAILURE,
  // Steamer Channel
  SET_STREAMER_CHANNEL,
  FETCH_STREAMER_CHANNEL_START,
  SET_STREAMER_CHANNEL_LOADING,
  FETCH_STREAMER_CHANNEL_FAILURE,
  FETCH_STREAMER_CHANNEL_SUCCESS,
  // Streaming Channel
  SET_STREAMING_CHANNEL_IS_PAID,
  FETCH_LIVE_STREAMING_CHANNEL_START,
  FETCH_LIVE_STREAMING_CHANNEL_FAILURE,
  FETCH_LIVE_STREAMING_CHANNEL_SUCCESS,
  // Streaming Messages
  SET_LIVE_STREAMING_CHANNEL_MESSAGES,
  APPEND_LIVE_STREAMING_CHANNEL_MESSAGE,
  // Live Streaming Channels
  FETCH_LIVE_STREAMING_CHANNELS_START,
  FETCH_LIVE_STREAMING_CHANNELS_SUCCESS,
  FETCH_LIVE_STREAMING_CHANNELS_FAILURE,
  // Fetch Live Performers
  FETCH_LIVE_PERFORMERS_START,
  FETCH_LIVE_PERFORMERS_SUCCESS,
  FETCH_LIVE_PERFORMERS_FAILURE,
  // Live Streaming Summary
  FETCH_LIVE_STREAMING_SUMMARY_START,
  FETCH_LIVE_STREAMING_SUMMARY_SUCCESS,
  FETCH_LIVE_STREAMING_SUMMARY_FAILURE,
  // Streaming Channel Payment
  LIVE_STREAMING_CHANNEL_PAYMENT_START,
  LIVE_STREAMING_CHANNEL_PAYMENT_FAILURE,
  LIVE_STREAMING_CHANNEL_PAYMENT_SUCCESS,
  // Live Streaming Tip Payment
  ADD_LIVE_STREAMING_TIP_PAYMENT,
  REMOVE_LIVE_STREAMING_TIP_PAYMENT
} from "./ActionConstant";

export function goLiveStart(data) {
  return {
    type: GO_LIVE_START,
    data,
  };
}

export function goLiveSuccess(data) {
  return {
    type: GO_LIVE_SUCCESS,
    data,
  };
}

export function goLiveFailure(data) {
  return {
    type: GO_LIVE_FAILURE,
    data,
  };
}

export function setStreamerChannel(data) {
  return {
    type: SET_STREAMER_CHANNEL,
    data,
  };
}

export function fetchStreamingChannelStart(data) {
  return {
    type: FETCH_LIVE_STREAMING_CHANNEL_START,
    data,
  };
}

export function fetchStreamingChannelSuccess(data) {
  return {
    type: FETCH_LIVE_STREAMING_CHANNEL_SUCCESS,
    data,
  };
}

export function fetchStreamingChannelFailure(data) {
  return {
    type: FETCH_LIVE_STREAMING_CHANNEL_FAILURE,
    data,
  };
}

export function setStreamerChannelLoading(data) {
  return {
    type: SET_STREAMER_CHANNEL_LOADING,
    data,
  };
}

export function fetchStreamerChannelStart(data) {
  return {
    type: FETCH_STREAMER_CHANNEL_START,
    data,
  };
}

export function fetchStreamerChannelSuccess(data) {
  return {
    type: FETCH_STREAMER_CHANNEL_SUCCESS,
    data,
  };
}

export function fetchStreamerChannelFailure(error) {
  return {
    type: FETCH_STREAMER_CHANNEL_FAILURE,
    error,
  };
}

export function setLiveStreamingChannelMessages(data) {
  return {
    type: SET_LIVE_STREAMING_CHANNEL_MESSAGES,
    data,
  };
}

export function appendStreamingChannelMessage(data) {
  return {
    type: APPEND_LIVE_STREAMING_CHANNEL_MESSAGE,
    data,
  };
}

export function setLiveStreamingChannelIsPaid(data) {
  return {
    type: SET_STREAMING_CHANNEL_IS_PAID,
    data,
  };
}

export function fetchLiveStreamingChannelsStart(data) {
  return {
    type: FETCH_LIVE_STREAMING_CHANNELS_START,
    data,
  };
}

export function fetchLiveStreamingChannelsSuccess(data) {
  return {
    type: FETCH_LIVE_STREAMING_CHANNELS_SUCCESS,
    data,
  };
}

export function fetchLiveStreamingChannelsFailure(error) {
  return {
    type: FETCH_LIVE_STREAMING_CHANNELS_FAILURE,
    error,
  };
}

export function fetchLivePerformersStart(data) {
  return {
    type: FETCH_LIVE_PERFORMERS_START,
    data,
  };
}

export function fetchLivePerformersSuccess(data) {
  return {
    type: FETCH_LIVE_PERFORMERS_SUCCESS,
    data,
  };
}

export function fetchLivePerformersFailure(error) {
  return {
    type: FETCH_LIVE_PERFORMERS_FAILURE,
    error,
  };
}

export function fetchLiveStreamingSummaryStart(data) {
  return {
    type: FETCH_LIVE_STREAMING_SUMMARY_START,
    data,
  };
}

export function fetchLiveStreamingSummarySuccess(data) {
  return {
    type: FETCH_LIVE_STREAMING_SUMMARY_SUCCESS,
    data,
  };
}

export function fetchLiveStreamingSummaryFailure(error) {
  return {
    type: FETCH_LIVE_STREAMING_SUMMARY_FAILURE,
    error,
  };
}

export function liveStreamingChannelPaymentStart(data) {
  return {
    type: LIVE_STREAMING_CHANNEL_PAYMENT_START,
    data,
  };
}

export function liveStreamingChannelPaymentSuccess(data) {
  return {
    type: LIVE_STREAMING_CHANNEL_PAYMENT_SUCCESS,
    data,
  };
}

export function liveStreamingChannelPaymentFailure(error) {
  return {
    type: LIVE_STREAMING_CHANNEL_PAYMENT_FAILURE,
    error,
  };
}

export function addLiveStreamingTipPayment (data) {
  return {
    type: ADD_LIVE_STREAMING_TIP_PAYMENT,
    data,
  };
}

export function removeLiveStreamingTipPayment (data) {
  return {
    type: REMOVE_LIVE_STREAMING_TIP_PAYMENT,
    data,
  };
}
